module.exports = __webpack_public_path__ + "img/listing-saya.7f879c83.svg";